import { render, staticRenderFns } from "./ConferenceBookings.vue?vue&type=template&id=7c5c2590"
import script from "./ConferenceBookings.vue?vue&type=script&lang=js"
export * from "./ConferenceBookings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports